@if (isWelcomePage) {
  <router-outlet></router-outlet>
} @else if (isReady) {
  <nz-spin [nzSpinning]="authState.snapshot.busy">
    <nz-layout class="app-layout">
      @for (a of errorState.alerts$ | async; track a.id) {
        <nz-alert nzType="error" [nzMessage]="a.subject" nzShowIcon nzCloseable (nzOnClose)="closeError(a.id)"></nz-alert>
      }

      <nz-header class="app-header" nz-row nzAlign="middle">
        <nz-space nz-col nzAlign="center" [routerLink]="['/']">
          <button nz-button nzType="text" nzShape="circle"
            i18n-nzTooltipTitle nzTooltipTitle="Refresh" nzTooltipPlacement="bottom" nz-tooltip
            (click)="$event.stopPropagation(); window.location.reload()"
          ><span nz-icon nzType="reload"></span></button>
          <img class="logo" src="assets/images/logo-1.png" alt="logo" />
          @for (role of authState.roles; track role) {
            @if (role !== UserRole.Guest || authState.roles.length === 1) {
              <nz-tag [nzColor]="roleColor(role)">
                {{ role }}
              </nz-tag>
            }
          }
          @if (!authState.isAuthenticated) {
            <nz-tag nzColor="error">
              <span nz-icon nzType="exclamation-circle"></span>
              <span i18n>Not authenticated</span>
            </nz-tag>
          }
        </nz-space>

        <app-sse-status></app-sse-status>

        @if (authState.hasAnyRole(UserRole.Operator, UserRole.Admin)) {
          <app-scanner-controller
            class="scanner-status"
            nz-col
            [status]="state.snapshot.state"
            (pause)="state.pause()"
            (resume)="resumeLine()"
            (click)="showScanDialog.next(true)"
          >
          </app-scanner-controller>
        }
        @if (authState.hasAnyRole(UserRole.Operator, UserRole.Admin) && state.snapshot.state === ScannerStatus.Deciding) {
          @if (failedScan$ | async; as failedScan) {
            <app-scan-dialog
              [scan]="!isBadBucket(failedScan) ? failedScan : null"
              i18n-title
              title="Please review failed inspection #{{failedScan.sequenceInBatch}}"
              i18n-defaultActionTitle
              defaultActionTitle="Eject"
              [liveDecision]="true"
              [defaultActionNeedsReason]="true"
              (onStatusUpdate)="state.setManualInspectionResult($event)"
              (onClose)="onFailedBucketDialogDecision($event)"
              (onAction)="onFailedBucketDialogDecision('Eject', $event)"
            ></app-scan-dialog>
          }
        }
        @if (state.snapshot.state === ScannerStatus.Ejected && (failedScan$ | async); as failedScan) {
          <app-scan-dialog
            [scan]="failedScan"
            i18n-title
            title="Please remove the bucket and press continue"
            i18n-defaultActionTitle
            defaultActionTitle="Continue"
            i18n-extraActionTitle
            extraActionTitle="Bypass PO"
            [defaultActionNeedsReason]="true"
            (onExtraAction)="authState.hasAnyRole(UserRole.Operator, UserRole.Admin) && batchState.bypass(failedScan.productionBatchId)"
            (onStatusUpdate)="authState.hasAnyRole(UserRole.Operator, UserRole.Admin) && state.setManualInspectionResult($event)"
            (onClose)="authState.hasAnyRole(UserRole.Operator, UserRole.Admin) && onEjectedBucketDialogDecision($event)"
            (onAction)="authState.hasAnyRole(UserRole.Operator, UserRole.Admin) && onEjectedBucketDialogDecision('Continue', $event)"
          ></app-scan-dialog>
        }

        <nz-space class="header-action-space" nz-col nzAlign="center">
          <app-line-status-indicators [line]="line"></app-line-status-indicators>

          <div style="display: inline-flex; margin-inline-start: 1cm; margin-inline-end: 2cm">
            <button
              nz-button
              nzType="default"
              nzSize="large"
              i18n-nzTooltipTitle="@@3855231854639462995" nzTooltipTitle="Turn on the camera light"
              nzTooltipPlacement="bottom"
              nz-tooltip
              [disabled]="!authState.hasAnyRole(UserRole.Operator, UserRole.Admin)"
              style="color: #faad14; border-start-end-radius: 0; border-end-end-radius: 0"
              (click)="requestSetCameraLight(true)"
            >
              <span nz-icon nzType="bulb" nzTheme="fill"></span>
            </button>
            @if (lightLevel; as level) {
              <span
                class="camera-light-level"
                [class.camera-light-level-mismatch]="level.mismatch"
                nz-tooltip
                nzTooltipPlacement="bottom"
                [nzTooltipTitle]="level.tooltip"
              >
                @if (level.mismatch) {
                  <span nz-icon nzType="warning" nzTheme="fill"></span>
                }
                {{ level.text }}
              </span>
            }
            <button
              nz-button
              nzType="default"
              nzSize="large"
              i18n-nzTooltipTitle="@@1217982599795565654" nzTooltipTitle="Turn off the camera light"
              nzTooltipPlacement="bottom"
              nz-tooltip
              [disabled]="!authState.hasAnyRole(UserRole.Operator, UserRole.Admin)"
              style="border-start-start-radius: 0; border-end-start-radius: 0; margin-inline-start: -1px"
              (click)="requestSetCameraLight(false)"
            >
              <span nz-icon nzType="bulb" nzTheme="outline"></span>
            </button>
          </div>

          <nz-space nz-col nzAlign="center">
            <button (click)="newBatchDialog.show()" nz-button nzType="default" nzShape="circle" nzSize="large" style="margin-inline-end: 8px"
              [disabled]="!authState.hasAnyRole(UserRole.Operator, UserRole.Admin)">
              <span nz-icon nzType="icons:add"></span>
            </button>
            <app-po-split-dialog #newBatchDialog [maxCount]="145" (onUpdate)="batchState.createBypassBatch($event)"></app-po-split-dialog>

            <button nz-dropdown nzTrigger="click" [nzDropdownMenu]="menu" nz-button nzType="default" nzShape="circle" nzSize="large"
              ><span nz-icon nzType="setting"></span
            ></button>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu>
                <li nz-menu-item nzDisabled="true">
                  <h4 i18n style="margin: 0">Machine: 1</h4>
                </li>
                <li nz-menu-item nzDisabled="true">
                  <nz-select [ngModel]="locale" (ngModelChange)="switchLocale($event)">
                    <nz-option nzValue="en-US" nzLabel="English"></nz-option>
                    <nz-option nzValue="he-IL" nzLabel="עברית"></nz-option>
                    <nz-option nzValue="ru" nzLabel="русский"></nz-option>
                  </nz-select>
                </li>
                <li nz-menu-item [routerLink]="['/', 'catalogs']">
                  <span nz-icon nzType="read" nzTheme="outline"></span>
                  <span i18n>Catalogs</span>
                </li>
                <li nz-menu-item [routerLink]="['/', 'models']">
                  <span nz-icon nzType="eye" nzTheme="outline"></span>
                  <span i18n>Inspection Models</span>
                </li>
                @if (authState.hasAnyRole(UserRole.Operator, UserRole.Admin)) {
                  <li nz-menu-item [routerLink]="['/', 'gpio']">
                    <span nz-icon nzType="api" nzTheme="outline"></span>
                    <span i18n>Gpio</span>
                  </li>
                }
                <li nz-menu-item [routerLink]="['/', 'reports']">
                  <span nz-icon nzType="file-excel" nzTheme="outline"></span>
                  <span i18n>Reports</span>
                </li>
                <li nz-menu-item>
                  <a href="assets/manual/en/index.html" target="_blank" rel="noopener">
                    <span nz-icon nzType="book" nzTheme="outline"></span>
                    <span i18n="@@menu.manualEnglish">Manual (English)</span>
                  </a>
                </li>
                <li nz-menu-item>
                  <a href="assets/manual/he/index.html" target="_blank" rel="noopener">
                    <span nz-icon nzType="book" nzTheme="outline"></span>
                    <span i18n="@@menu.manualHebrew">Manual (Hebrew)</span>
                  </a>
                </li>
                @if (authState.hasAnyRole(UserRole.Operator, UserRole.Admin)) {
                  <li nz-menu-item (click)="calibrate()">
                    <span nz-icon nzType="aim" nzTheme="outline"></span>
                    <span i18n>Calibrate</span>
                  </li>
                  <li nz-menu-item (click)="batchState.suspendAll()">
                    <span nz-icon nzType="clear" nzTheme="outline"></span>
                    <span i18n>Suspend All POs</span>
                  </li>
                }
                <li nz-menu-item [routerLink]="['/', 'manage-roles']">
                  <span nz-icon nzType="lock" nzTheme="outline"></span>
                  <span i18n>Manage Your Roles</span>
                </li>
                <li nz-menu-item [routerLink]="['/', 'about']">
                  <span nz-icon nzType="info-circle" nzTheme="outline"></span>
                  <span i18n>About</span>
                </li>
                <hr />
                <nz-row>
                  <span i18n>Version:</span>
                </nz-row>
                <div style="overflow-wrap: break-word; width: 300px">{{ state.snapshot.version }}</div>
              </ul>
            </nz-dropdown-menu>
          </nz-space>
        </nz-space>
      </nz-header>
      <nz-content>
        <div class="inner-content" style="display: flex">
          <router-outlet></router-outlet>
        </div>
      </nz-content>
    </nz-layout>
  </nz-spin>

  <app-po-attach-dialog #attachDialog (onSelect)="attach($event)"
                        (onBypass)="batchState.bypass($event.id)"></app-po-attach-dialog>

  <nz-modal
    [(nzVisible)]="cameraLightSwitchConfirmVisible"
    [nzTitle]="cameraLightModalTitle"
    [nzFooter]="cameraLightFooter"
    (nzOnCancel)="cameraLightSwitchConfirmVisible = false"
  >
    <ng-template #cameraLightModalTitle>
      @if (_pendingLightOn) {
        <span i18n>Turn ON the camera light?</span>
      } @else {
        <span i18n>Turn OFF the camera light?</span>
      }
    </ng-template>
    <ng-container *nzModalContent>
      @if (_pendingLightOn) {
        <p i18n>Are you sure you want to turn ON the camera light?</p>
      } @else {
        <p i18n>Are you sure you want to turn OFF the camera light?</p>
      }
    </ng-container>
    <ng-template #cameraLightFooter>
      <button nz-button nzType="default" (click)="cameraLightSwitchConfirmVisible = false" autofocus>
        <span nz-icon nzType="close"></span>
        <span i18n>No</span>
      </button>
      <button nz-button nzType="primary" (click)="confirmSetCameraLight()">
        <span nz-icon nzType="check"></span>
        <span i18n>Yes</span>
      </button>
    </ng-template>
  </nz-modal>
  <!-- DEV-282: reason popup for the header Resume while the scanner is stopped on a bucket (the scan dialogs have their own) -->
  <app-operator-reason-dialog
    #continueReasonDialog
    (reasonSelected)="onContinueReasonSelected($event)"
  ></app-operator-reason-dialog>
}
